<template>
    <div class="modelManagement" v-loading="$store.state.loading">
        <div style="
        display: flex;
        align-items: flex-end;
        justify-content: flex-start;
      ">
            <div class="text">{{ flag == 1 ? "模型管理" : '样本管理' }}</div>
            <div v-if="flag == 2" @click="flag = 1" style="margin-left: 24px;color: #bbbbbb;cursor: pointer;">{{
                '< 返回'
                }}
            </div>
        </div>

        <el-divider></el-divider>

        <div v-if="flag == 1">
            <div class="search">
                <span class="text3">模型名称</span>
                <el-input v-model="name"></el-input>
                <span class="text3">监测位置</span>
                <el-input v-model="position"></el-input>
                <span class="text3">设备名称</span>
                <el-input v-model="remark"></el-input>
                <button class="btn-1" @click="getModelList">查询</button>
                <button class="btn-1" @click="reset">重置</button>
            </div>

            <el-table size="mini" ref="Table" :data="modelList" class="Table" :highlight-current-row="true"
                      :row-class-name="tableRowClassName" :header-cell-style="{
            fontSize: '0.875rem',
            color: 'rgba(127, 132, 136, 1)',
            borderColor: '#244447',
            backgroundColor: 'rgba(180, 180, 180, .1)',
            height: '3.375rem',

          }" :row-style="{
  fontSize: '0.875rem',
  color: '#B4B4B4',
  height: '3rem',
}">
                <el-table-column header-align="center" align="center" label="序号" width="50">
                    <template slot-scope="scope">
                        {{ (pageNo - 1) * pageSize + (scope.row.index + 1) }}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="name" label="模型名称">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="count" label="样本数" width="70">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="sensorId" label="传感器ID">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="position" label="监测位置">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="uuid" label="终端UUID">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="elevatorName" label="设备名称">
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="createTime" label="训练时间"
                                 show-overflow-tooltip>
                </el-table-column>
                <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                        <span class="text2" @click="goDetail(scope.row)"> 查看</span>
                        <span class="text2" @click="openUpdateDialog(scope.row)"> 修改名称</span>
                        <span class="text2" @click="deleteModel(scope.row.id)"> 删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination style="margin: 0px auto; display: table" :total="total" :page.sync="pageNo"
                        :limit.sync="pageSize"
                        @pagination="getModelList"></Pagination>
        </div>

        <div v-if="flag == 2" style="display: flex;flex-direction: column;justify-content: space-between;flex: 1;">
            <el-table size="mini" ref="Table" :data="sampleList" class="Table" :highlight-current-row="true"
                      :row-class-name="tableRowClassName" style="padding: 0 2%; box-sizing: border-box"
                      @row-click="clickRow" :header-cell-style="{
            fontSize: '0.875rem',
            color: 'rgba(127, 132, 136, 1)',
            borderColor: '#244447',
            backgroundColor: 'rgba(180, 180, 180, .1)',
            height: '3.375rem',

          }" :row-style="{
  fontSize: '0.875rem',
  color: '#B4B4B4',
  height: '3rem',
}">
                <el-table-column header-align="center" align="center" label="序号" width="50">
                    <template slot-scope="scope">
                        {{ scope.row.index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column header-align="center" align="center" prop="fileName" label="样本文件名">
                </el-table-column>
                <el-table-column header-align="center" align="center" width="150" prop="startPos" label="起始采样点">
                </el-table-column>
                <el-table-column header-align="center" align="center" width="150" prop="endPos" label="结束采样点">
                </el-table-column>
                <el-table-column header-align="center" align="center" width="150" label="样本类型">
                    <template slot-scope="scope">
                        {{ scope.row.sampleType == 1 ? "正样本" : "负样本" }}
                    </template>
                </el-table-column>
                <el-table-column align="center" width="300" label="操作">
                    <template slot-scope="scope">
<!--                        <span class="text2" @click="playAudio(scope.row)"> {{ scope.row.playText }}</span>-->
                        <span class="text2" @click="deleteSample(scope.row.id)"> 删除</span>
                    </template>
                </el-table-column>
            </el-table>

            <div style="flex: 1;margin: 0 20px">
                <player style="opacity: 0.8;" ref="Player" @ready="playerReady" @status-changed="playerStatusChanged"/>
                <div style="margin-top: 12px;">
                    <button class="btn-1" @click="clickPlay">{{playBtnText}}</button>
                    <button class="btn-1" @click="previous">上一个</button>
                    <button class="btn-1" @click="next">下一个</button>
                    <button class="btn-1" @click="updatePos">更新区间</button>
                </div>
            </div>
        </div>

        <el-dialog title="修改模型名称" :visible.sync="visible" :modal-append-to-body="false"
                   :close-on-click-modal="false">
            <div class="modelName">
                <span>模型名称</span>
                <el-input v-model="modelName"></el-input>
            </div>
            <div style="text-align: right; padding-top: 1rem">
                <button class="btn-1" @click="updateModelName">确定</button>
                <button class="btn-1" @click="visible = false">取消</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import Pagination from "../../components/Pagination.vue";
import player from "../../components/audio-player.vue";

export default {
    components: {
        Pagination,
        player
    },
    data() {
        return {
            flag: 1,
            pageNo: 1,
            pageSize: 10,
            total: 0,
            modelList: [],
            name: '',
            position: '',
            remark: '',
            modelName: '',
            visible: false,
            curModelId: '',
            sampleList: [],
            curIndex: 0,
            curSampleId: '',
            playBtnText: '播放',
        };
    },
    mounted() {
        this.getModelList();
    },
    methods: {
        // playInterval() {
        //     let startTime = (this.$refs.Player.selectedStartPos) / this.$refs.Player.sampleRate;
        //     let endTime = this.$refs.Player.selectedEndPos / this.$refs.Player.sampleRate;
        //     this.$refs.Player.waveSurfer.play(startTime, endTime);
        // },
        reset() {
            this.name = ''
            this.position = ''
            this.remark = ''
            this.getModelList()
        },
        updatePos() {
            this.$confirm('是否确定更新该样本？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    id: this.curSampleId,
                    startPos: this.$refs.Player.selectedStartPos,
                    endPos: this.$refs.Player.selectedEndPos
                }
                this.$api.yysy.updateModelSample(params).then((res) => {
                    if (res.code == 200) {
                        this.$message.success('更新成功');
                        this.getModelSampleList(null, this.curModelId, this.sampleList[this.curIndex]);
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            }).catch(() => {
            });
        },
        clickRow(row){
            this.curSampleId = row.id
            const wavUrl1 = "/api" + row.fileName.slice(15);
            this.$refs.Player.waveSurfer.load(wavUrl1);
            this.$refs.Player.selectedStartPos = row.startPos
            this.$refs.Player.selectedEndPos = row.endPos
            this.$refs.Player.drawSelect()

        },
        clickPlay(){
            this.$refs.Player.play();
        },
        previous() {
            if (this.curIndex === 0) {
                this.$message.warning('已经是第一个了')
                return
            }
            let row = this.sampleList[this.curIndex - 1];
            this.clickRow(row);
            // this.playAudio(this.sampleList[this.curIndex - 1])
            this.$refs.Table.setCurrentRow(row);
            this.curIndex--;
        },
        next() {
            if (this.curIndex === this.sampleList.length - 1) {
                this.$message.warning('已经是最后一个了')
                return
            }

            let row = this.sampleList[this.curIndex + 1];
            this.clickRow(row);
            // this.playAudio(this.sampleList[this.curIndex + 1])
            this.$refs.Table.setCurrentRow(row);
            this.curIndex++;
        },
        playerReady(){
            this.$refs.Player.play();
        },
        playerStatusChanged(title,status) {
            console.log('status', status);
            if (status === "playing") {
                this.playBtnText = '暂停';
            } else {
                this.playBtnText = '播放';
            }
        },
        playAudio(row) {
            this.curSampleId = row.id
            if (this.curIndex === row.index) {
                if (row.playText === "播放") {
                    this.$refs.Player.waveSurfer.play();
                    row.playText = "暂停";
                } else {
                    this.$refs.Player.waveSurfer.pause();
                    row.playText = "播放";
                }
                this.$forceUpdate()
            } else {
                const wavUrl1 = "/api" + row.fileName.slice(15);
                this.$refs.Player.waveSurfer.load(wavUrl1);
                this.$refs.Player.selectedStartPos = row.startPos
                this.$refs.Player.selectedEndPos = row.endPos
                this.$refs.Player.drawSelect()

                // this.$refs.Player.waveSurfer.play(startTime, endTime);
                // this.$nextTick(() => {
                //     setTimeout(() => {
                //         this.$refs.Player.waveSurfer.play();
                //         this.sampleList[this.curIndex].playText = "播放";
                //         row.playText = "暂停";
                //         this.curIndex = row.index
                //         this.$forceUpdate()
                //     }, 1000)
                // })
            }
        },
        deleteSample(id) {
            this.$confirm('是否确定删除该样本？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    id: id,
                };
                this.$api.yysy.deleteModelSample(params).then((res) => {
                    if (res.code == 200) {
                        this.getModelSampleList(null, this.curModelId, this.sampleList[0]);
                    }
                });
            }).catch(() => {
            });
        },
        updateModelName() {
            const params = {
                id: this.curModelId,
                modelName: this.modelName,
            }
            this.$api.yysy.updateModel(params).then((res) => {
                if (res.code == 200) {
                    this.visible = false;
                    this.$message.success('修改成功');
                    this.getModelList();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        openUpdateDialog(row) {
            this.visible = true;
            this.modelName = row.name.slice(0, row.name.lastIndexOf("-"));
            this.curModelId = row.id;
        },
        deleteModel(id) {
            this.$confirm('是否确定删除该模型？', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const params = {
                    modelId: id,
                };
                this.$api.yysy.delModel(params).then((res) => {
                    if (res.code == 200) {
                        this.getModelList();
                    }
                });
            }).catch(() => {
            });
        },
        goDetail(row) {
            this.flag = 2
            this.curModelId = row.id;
            this.getModelSampleList(row);
        },
        getModelSampleList(data, id, row) {
            const params = {
                modelId: id || data.id,
            };
            this.$api.yysy.getModelSampleList(params).then((res) => {
                if (res.code == 200) {
                    this.sampleList = res.data;
                    this.sampleList.forEach((item) => {
                        item.playText = '播放'
                    });

                    if (data) {
                        //初始化音频
                        this.$nextTick(() => {
                            if (this.sampleList.length == 0) {
                                return
                            }
                            this.curIndex = 0
                            this.curSampleId = this.sampleList[0].id
                            //接口返回的是/root/wind-power/data/warning/7B7785DF0131/1693395176.2.wav
                            //只取/waning/7B7785DF0131/1693395176.2.wav
                            const wavUrl1 =
                                "/api" + this.sampleList[0].fileName.slice(15);
                            let sampleRate =
                                data.position.split("#")[0] == "叶片" ? 44100 : 8000;
                            if (!this.$refs.Player.waveSurfer) {
                                this.$refs.Player.initPlayer(sampleRate);
                            }
                            this.$refs.Player.waveSurfer.load(wavUrl1);
                            this.$refs.Player.selectedStartPos = this.sampleList[0].startPos
                            this.$refs.Player.selectedEndPos = this.sampleList[0].endPos
                            this.$refs.Player.drawSelect()
                            this.$refs.Table.setCurrentRow(this.sampleList[0]);
                        });
                    } else {
                        //更新样本和删除的操作
                        // this.playAudio(row)
                        // this.$refs.Player.waveSurfer.pause();
                    }
                }
            });
        },
        getModelList() {
            const params = {
                page: this.pageNo,
                size: this.pageSize,
                name: this.name, //模型名称
                position: this.position, //监测位置
                remark: this.remark, //风机名称
            };
            this.$api.yysy.pageModel(params).then((res) => {
                if (res.success) {
                    this.modelList = res.data.records;
                    this.total = res.data.total;
                }
            });
        },
        tableRowClassName({row, rowIndex}) {
            //配置表格行的index
            row.index = rowIndex;
        },
    },
    computed: {},
};
</script>

<style lang="less" scoped>
.modelManagement {
  background: var(--cardbg-color);
  height: 100%;
  min-width: 1440px;
  display: flex;
  flex-direction: column;

  /* 清除表格横线 */

  /deep/ .el-table__row > td,
  th {
    border-color: var(--tableLine-color);
  }

  /deep/ .el-table .cell {
    line-height: 1.5rem !important;
  }

  /deep/ .el-pagination {
    display: flex;
    align-items: center;
    height: 1.75rem !important;
  }

  /deep/ .el-pagination .el-select .el-input {
    width: 6.25rem !important;
  }

  /deep/ .el-pagination .btn-next .el-icon {
    font-size: 0.75rem !important;
  }

  /deep/ .el-pagination .btn-prev .el-icon {
    font-size: 0.75rem !important;
  }

  /deep/ .el-pagination__total {
    font-size: 0.875rem !important;
    min-width: 2.2188rem !important;
  }

  /deep/ .el-pagination .el-select .el-input .el-input__inner {
    font-size: 0.875rem !important;
    width: 6.25rem !important;
  }

  /deep/ .el-pager li {
    padding: 0 0.25rem !important;
    font-size: 0.8125rem !important;
    min-width: 2.2188rem !important;
  }

  /deep/ .el-pagination button,
  .el-pagination span:not([class*="suffix"]) {
    min-width: 2.2188rem !important;
  }

  /deep/ .el-pagination__jump {
    margin-left: 1.5rem !important;
    font-size: 0.8125rem !important;
  }

  .search {
    display: flex;
    margin-bottom: 15px;
    margin-left: 1rem;
    align-items: center;
    justify-content: flex-start;

    .text3 {
      color: white;
      font-size: 1rem;
    }

    /deep/ .el-input {
      width: 12rem;
      height: 2.5rem;
      margin: 0px 25px;
    }

    /deep/ .el-input__inner {
      border: 1px solid #c0e9ff1f;
      background: #24444757;
      color: #fff;
      border-radius: 0px;
    }
  }


  .btn3 {
    width: 4.6875rem;
    height: 1.875rem;
    background: #1f848d;
    border-radius: 0.125rem;
    border: 0.0625rem solid #1f848d;
    color: white;
    font-size: 0.875rem;
    cursor: pointer;
  }

  .btn3:hover {
    background: #259faa;
  }

  .btn4 {
    width: 4.6875rem;
    height: 1.875rem;
    border-radius: .125rem;
    border: .0625rem solid #6C9CB5;
    background: transparent;
    color: white;
    font-size: .875rem;
    margin-left: 12px;
    cursor: pointer;
  }

  .btn4:hover {
    background: #124f55;
  }

  .text {
    margin-top: 2.125rem;
    margin-left: 1rem;
    font-size: 1.75rem;
    font-weight: bold;
    color: #44d7b6;
  }

  /deep/ .el-divider {
    background-color: #244447;
    margin-top: 1rem;
    margin-bottom: 1.5rem;
  }

  // /deep/ .el-dialog {
  //   margin-top: 8vh !important;
  // }

  // /deep/.el-dialog__body {
  //   // padding: 25px 20px !important;
  //   color: #ffffff;
  //   background: #182732;
  // }

  // /deep/ .el-dialog__header {
  //   color: white;
  //   background: linear-gradient(270deg,
  //       rgba(17, 33, 38, 0.3) 0%,
  //       rgba(95, 227, 229, 0.3) 100%);
  //   border-left: 2px solid #d5f2ff;
  //   padding: 10px 17px 10px;
  // }

  // /deep/ .el-dialog__title {
  //   color: #ffffff;
  //   padding-left: 56px;
  //   font-size: .875rem;
  //   line-height: 1.5rem;

  // }

  // /deep/ .el-dialog__header::before {
  //   position: absolute;
  //   top: .375rem;
  // }

  /deep/ .el-dialog {
    background: #344142ec;
    width: 520px;
    // height: 43.75rem;
  }

  .btn-1 {
    margin-left: 15px;
    width: 4.6875rem;
    height: 1.875rem;
    background: #44d7b6;
    border-radius: 2px;
    font-size: 0.875rem;
    color: #ffffff;
    border: none;
    cursor: pointer;
  }

  .btn-1:hover {
    background: #66f8d7;
  }

  .btn-1:active {
    background: #299f85;
  }

  .modelName {
    /deep/ .el-input {
      width: 280px;
      height: 40px;
      margin: 25px 25px 10px;
    }

    /deep/ .el-input__inner {
      border-radius: 4px;
      border: 3px solid #c0e9ff1f;
      background: #24444757;
      color: #fff;
      border-radius: 0px;
    }
  }

  .Table {
    width: 99%;
    background-color: transparent;
    // height: 33rem;
    overflow: auto;

    .text2 {
      cursor: pointer;
      border-bottom: 1px solid;
      padding-bottom: 1px;
    }
  }
}
</style>
  


// WEBPACK FOOTER //
// src/pages/model/index.vue